const state = {
  keywords: [], //搜索历史
};

const mutations = {
  addKeyword: (state, key) => {
    if (!state.keywords.includes(key)) {
      state.keywords.unshift(key);
      state.keywords = state.keywords.slice(0, 8);
    }
  },
  delKeyword: (state, key) => {
    if (key) {
      state.keywords = state.keywords.filter((item) => item !== key);
    } else {
      state.keywords = [];
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
